module.exports = __webpack_public_path__ + "media/images/pro_logo-1069ec1f36749494c3f23ce9721b2d2e.png";